import { toPublicURL } from '@plone/volto/helpers/Url/Url';
import { SchemaModifier } from '../types';

const occasionModifier: SchemaModifier = (
  content,
  main,
  parts,
  state,
  partial,
) => {
  if (content?.occasion_title) {
    main['name'] = content.occasion_title;
  }
  // Occasions often have a plain slug as @id (e.g. "durchfuehrungsname").
  // When that's the case, construct the full URL from parent + slug.
  const rawId = content?.['@id'] as string | undefined;
  if (
    content?.parent?.['@id'] &&
    rawId &&
    !rawId.includes('/') &&
    !rawId.startsWith('http')
  ) {
    main['url'] = main['identifier'] =
      `${toPublicURL(content.parent['@id'])}/${rawId}`;
  }
  if (content?.parent?.title) {
    if (main['name']) {
      main['description'] = main['name'];
    }
    main['name'] = content?.parent?.title;
  }
  if (content?.final_application_date) {
    main['applicationDeadline'] = content.final_application_date;
  }
  if (content?.application_start) {
    main['applicationStartDate'] = content.application_start;
  }
  if (content?.occasion_start) {
    main['startDate'] = content.occasion_start;
  }
  if (content?.occasion_end) {
    main['endDate'] = content.occasion_end;
  }
  if (content?.duration) {
    main['timeToComplete'] = content.duration;
  }
  if (content?.total_places) {
    main['maximumPhysicalAttendeeCapacity'] = content.total_places;
  }
  if (content?.free_places) {
    main['remainingAttendeeCapacity'] = content.free_places;
  }
  if (content?.course_management) {
    main['instructor'] = content.course_management;
  }
  if (content?.place) {
    main['location'] = {
      '@type': 'Place',
      name: content.place,
    };
  } else if (content?.location?.title || content?.location?.value) {
    main['location'] = {
      '@type': 'Place',
      name: content.location.title || content.location.value,
    };
  }
};

export default occasionModifier;
